import { render, staticRenderFns } from "./TheHot.vue?vue&type=template&id=510a5f30&scoped=true"
import script from "./TheHot.vue?vue&type=script&lang=js"
export * from "./TheHot.vue?vue&type=script&lang=js"
import style0 from "./TheHot.vue?vue&type=style&index=0&id=510a5f30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510a5f30",
  null
  
)

export default component.exports